module.exports = __webpack_public_path__ + "static/media/AdobeStock_ARUFON_slider.c02bec3b.jpeg";